import { DevTool } from '@hookform/devtools';
import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Button, Card, CircularProgress, Modal, TextField, Chip, Typography, FormControl, FormControlLabel, FormHelperText, FormLabel, Grid, IconButton, Radio, RadioGroup, Table, TableHead, TableRow, TableCell, TableContainer, TableBody } from '@mui/material';
import { Stack } from '@mui/system';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from "yup";
import SnackBarUI from '../../comman/SnackBarUI';
import { getAllQuestionAnswerAction } from '../../redux/toolkit/question-answer/getAllQuestionAnswer';
import { updateQuestionAnswerAction } from '../../redux/toolkit/question-answer/updateQuestionAnswer';
import PropTypes from 'prop-types';

import Paper from '@mui/material/Paper';
import { uplodImageAction } from '../../redux/toolkit/image/uplodImage';
import { styled } from '@mui/material/styles';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';


// schema
const qns_ans_schema = yup.object({
    question: yup.string().required('Question is required.'),
    question_type: yup.number().required('Question type is required.'),
    questionId: yup.number().required('questionId  is required.'),
    // type: yup.string().required('question type is required'),


}).required();


export default function UpdateQnsAns({ qns_id, state, setState }) {
    // state
    const dispatch = useDispatch()
    const updateQns = useSelector(state => state.updateQuestionAnswer)
    const { status, message, loading } = updateQns
    const getQns = useSelector(state => state.getSingleQuestionAnswer)
    const { data: { data_type, question,questionId, answer_type: answerType, question_type, ans_options = [], options, type: qType, file_url, title: Title, difficulty } } = getQns
    const input = {
        option: null,
        correct: null
    }
    const [answerOption, setAnswerOption] = useState(input)
    const [ansArr, setAnsArr] = useState(options)
    const [file, setFile] = useState('')
    // const [title,setTitle]=useState('')
    const [type, setType] = useState('')
    const [questiontype, setquestion_type] = useState(0)
    const [diff, setDiff] = useState('')
    const [fileLoader, setFileLoader] = useState(false)




    const { register, setValue, reset, watch, control, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(qns_ans_schema),
        defaultValues: {
            question: question,
            answer_type: answerType,
            question_type: question_type,
            questionId: questionId,
            ans_options: ans_options,
            title: Title,
            data_type: data_type,
        }
    });






    const answer_type = watch("answer_type");
    const watchedQuestionType = watch("question_type");
    const watchedquestionId = watch("questionId");
    const watchedans_options = watch("ans_options");

    const [snack, setSnack] = useState(false)

    // fn
    const handleQns = async (data) => {

        await dispatch(updateQuestionAnswerAction({ qns_id: qns_id, chipData, ...data }))
        await dispatch(getAllQuestionAnswerAction({ is_deleted: false }))
        setSnack(true)
        setState(false)
    }

    const handleClose = function () {
        setState(false)
    }
    const handleAddAnsOpt = () => {


        const foundDuplicate = ansArr.find(element => element === answerOption.option);
        if (foundDuplicate !== undefined) return
        setAnsArr(prev => [...prev, answerOption])
        setAnswerOption({
            option: "",
            correct: false,
        })
    }

    const changeOptInput = (e) => {
        setAnswerOption({ ...answerOption, [e.target.id]: e.target.value })
    }

    const handleFileUpload = async (e) => {
        setFileLoader(true)
        const formData = new FormData();

        formData.set("file", e.target.files[0]);

        let uploadedImg = await dispatch(uplodImageAction(formData))
        const imgStr = uploadedImg?.payload?.data?.url;
        setFile(uploadedImg?.payload?.data?.url)
        setValue('file', imgStr)

        if (e.target.files[0].type == 'video/*' || e.target.files[0].type == 'audio/mp3') {
            const fileUrl = URL.createObjectURL(e.target.files[0]);
            const media = new Audio(fileUrl);
            media.onloadedmetadata = function () {
                // setTimeDuration(media.duration)
            };
        }
        setFileLoader(false)


    }




    const handleQuestionTypeChange = (event) => {
        const value = parseInt(event.target.value, 10);
        setValue('question_type', value);
    };


    const handleDelAnsOpt = (i) => {
        const tempArr = JSON.parse(JSON.stringify(ansArr));
        tempArr.splice(i, 1)

        setAnsArr([...tempArr])
        setAnswerOption(input)
    }


    const ListItem = styled('li')(({ theme }) => ({
        margin: theme.spacing(0.5),
    }));

    const [chipData, setChipData] = useState([]); // Array of strings
    const [chipInput, setChipInput] = useState("");

    const handleInputChange = (event) => {
        setChipInput(event.target.value);
    };





    const [dataType, setDataType] = useState('')

    const handleChange = (event) => {
        setDataType(event.target.value);
    };

    const handleAddChip = (event) => {
        if (event.key === "Enter" && chipInput.trim() !== "") {
            const trimmedInput = chipInput.trim();
            if (!chipData.includes(trimmedInput)) {
                const updatedChips = [...chipData, trimmedInput];
                setChipData(updatedChips); // Update local state
                setValue("ans_options", updatedChips); // Sync with form
            }
            setChipInput(""); // Clear input field
            event.preventDefault();
        }
    };

    const handleDelete = (chipToDelete) => () => {
        const updatedChips = chipData.filter((chip) => chip !== chipToDelete);
        setChipData(updatedChips); // Update local state
        setValue("ans_options", updatedChips); // Sync with form
    };



    const [answer, setAnswer] = useState({
        "OptionText": "",
        "Precode": ""
    });
    const [answerIndex, setAnswerIndex] = useState(0)
    const [editAnswer, setEditAnswer] = useState(false)


    const handleOptionChange = (e) => {
        setAnswer({ ...answer, OptionText: e.target.value })
    }

    const handlePreCodeChange = (e) => {
        setAnswer({ ...answer, Precode: e.target.value })
    }

    const handEditAnswer = () => {
        let dataToUpdate = answer
        let tempArr = [...ans_options]

        tempArr.splice(answerIndex, 1, dataToUpdate)
        // setAnsOption(tempArr)
        setValue("ans_options", tempArr); // Sync with form's default values


        setAnswer({
            "OptionText": "",
            "Precode": ""
        })
        setEditAnswer(false);

    }




    useEffect(() => {
        let defaultValues = {};
        defaultValues.question = question;
        defaultValues.answer_type = answerType;
        defaultValues.title = Title;
        defaultValues.question_type = question_type
        defaultValues.questionId = questionId
        defaultValues.ans_options = ans_options
        defaultValues.type = qType;
        defaultValues.data_type = data_type
        // setChipData(ans_options)
        setFile(file_url)
        // setTitle(title)
        setType(qType)

        if (Array.isArray(ans_options)) {
            setChipData(ans_options);
            setValue("ans_options", ans_options); // Sync with form's default values
        }


        setValue('title', Title)
        setDiff(difficulty)
        // setValue(type,qType)
        reset({ ...defaultValues });
    }, [question, answer_type])

    useEffect(() => {
        setAnsArr(options)
    }, [options])





    return (
        <>
            <Modal sx={{ overflow: 'scroll' }} open={state} onClose={handleClose}>
                <Box className='modal_box'>
                    <Card sx={{ width: 500, p: 5 }}>
                        <Typography variant='h5' sx={{ mb: 5 }} align='center'>Update Question Answer</Typography>
                        <form onSubmit={handleSubmit(handleQns)}>
                            <Stack spacing={3}>
                                <FormControl>
                                    <FormLabel>Question Type</FormLabel>
                                    <RadioGroup onChange={handleQuestionTypeChange}>
                                        <Stack direction='row'>


                                            <FormControlLabel
                                                value={1}
                                                checked={watchedQuestionType == 1}
                                                control={<Radio />}
                                                label="Input"
                                                {...register('question_type')}
                                            />
                                            <FormControlLabel
                                                value={2}
                                                checked={watchedQuestionType == 2}
                                                control={<Radio />}
                                                label="Radio"
                                                {...register('question_type')}
                                            />
                                            <FormControlLabel
                                                value={3}
                                                checked={watchedQuestionType == 3}
                                                control={<Radio />}
                                                label="DropDown"
                                                {...register('question_type')}
                                            />
                                        </Stack>
                                    </RadioGroup>
                                    <FormHelperText error={errors?.question_type?.message}>{errors?.question_type?.message}</FormHelperText>
                                </FormControl>


                                {/* {(watchedQuestionType == 2 || watchedQuestionType == 3) &&
                                    <>

                                        <TextField
                                            label="Option"
                                            variant="outlined"
                                            placeholder="Enter option and press Enter"
                                            value={chipInput}
                                            onChange={handleInputChange}
                                            onKeyDown={handleAddChip}
                                            fullWidth
                                        />

                                        <Paper
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                flexWrap: 'wrap',
                                                listStyle: 'none',
                                                p: 0.5,
                                                m: 0,
                                                mt: 2,
                                            }}
                                            component="ul"
                                        >
                                            {chipData?.map((data, index) => (
                                                <ListItem key={index}>
                                                    <Chip
                                                        label={data}
                                                        onDelete={handleDelete(data)}
                                                    />
                                                </ListItem>
                                            ))}
                                        </Paper>
                                    </>
                                } */}


                                <Stack spacing={3} sx={{ marginTop: "20px" }}>
                                    {question && <TextField defaultValue={question} type='text' label="Question" variant="outlined" placeholder='Question' {...register('question')} error={errors?.question?.message} helperText={errors?.question?.message} />}
                                    {questionId && <TextField  defaultValue={questionId} type='text' label="Question Id" variant="outlined"  placeholder='Question ID' {...register('questionId')} error={errors?.questionId?.message} helperText={errors?.questionId?.message} />}

                                </Stack>






                                {
                                    (watchedQuestionType == 2 || watchedQuestionType == 3) && <Stack spacing={3} direction='row' sx={{ width: "100%" }}>

                                        <Stack sx={{ width: "90%" }} direction={"row"} gap={2}>
                                            <TextField
                                                label="OptionText"
                                                variant="outlined"
                                                placeholder="Enter OptionText"
                                                value={answer?.OptionText}
                                                onChange={handleOptionChange}
                                                fullWidth
                                            />

                                            <TextField
                                                label="Precode"
                                                variant="outlined"
                                                placeholder="Enter Precode"
                                                value={answer?.Precode}
                                                onChange={handlePreCodeChange}
                                                fullWidth
                                            />

                                        </Stack >

                                        {answer?.OptionText && editAnswer && <Button
                                            sx={{
                                                backgroundColor: "black",
                                                color: "white"
                                            }}
                                            onClick={() => handEditAnswer()}

                                        >Edit</Button>
                                        }
                                    </Stack>
                                }

                                {
                                    (watchedQuestionType == 1) &&
                                    <>
                                        <TextField disabled={true} defaultValue={data_type} type='text' label="data_type" variant="outlined" placeholder='data_type' {...register('data_type')} error={errors?.data_type?.message} helperText={errors?.data_type?.message} />

                                    </>
                                }


                                {(watchedQuestionType == 2 || watchedQuestionType == 3) && (watchedans_options?.length > 0) && <TableContainer component={Paper}>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>S.N. </TableCell>
                                                <TableCell align="right">Option Text</TableCell>
                                                <TableCell align="right">PreCode</TableCell>
                                                <TableCell align="right">Edit</TableCell>

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {watchedans_options.map((row, key) => (
                                                <TableRow
                                                    key={row.option}
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        {key + 1}
                                                    </TableCell>
                                                    <TableCell align="right">{row.OptionText}</TableCell>
                                                    <TableCell align="right">{row.Precode}</TableCell>
                                                    <TableCell align="right">
                                                        <Button
                                                            variant="contained"
                                                            onClick={() => { setAnswer(row); setAnswerIndex(key); setEditAnswer(true) }}
                                                        >Edit</Button>
                                                    </TableCell>

                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>}

                            </Stack>


                            <Stack spacing={3} sx={{ marginTop: "20px" }}>
                                {/* {question && <TextField defaultValue={question} type='text' label="Question" variant="outlined" placeholder='Question' {...register('question')} error={errors?.question?.message} helperText={errors?.question?.message} />} */}


                                <Stack direction='row' spacing={2}>
                                    <Button variant='contained' type='submit' disabled={loading}>{loading ? <CircularProgress /> : 'Update Q & A'}</Button>
                                    <Button variant='contained' color='error' onClick={handleClose}>Close</Button>
                                </Stack>
                            </Stack>
                        </form>
                    </Card>
                </Box>
            </Modal >

            <SnackBarUI state={snack} setState={setSnack} status={status} message={message} />
            <DevTool control={control} />
        </>
    )
}


UpdateQnsAns.propTypes = {
    qns_id: PropTypes.string,
    state: PropTypes.any,
    setState: PropTypes.any
};
